/*
======================================================
Premium Image With Text
======================================================
*/

class PremiumImageWithText {

    constructor(section){

        this.section = section;

        this.items = section.querySelectorAll('.reveal');

        this.init();

    }

    init(){

        if(!this.items.length) return;

        if(!('IntersectionObserver' in window)){

            this.items.forEach(item=>item.classList.add('active'));

            return;

        }

        const observer = new IntersectionObserver((entries)=>{

            entries.forEach(entry=>{

                if(entry.isIntersecting){

                    entry.target.classList.add('active');

                    observer.unobserve(entry.target);

                }

            });

        },{

            threshold:.15,
            rootMargin:"0px 0px -50px"

        });

        this.items.forEach(item=>{

            observer.observe(item);

        });

    }

}

function initPremiumSections(scope=document){

    scope.querySelectorAll('.piwt-section').forEach(section=>{

        if(section.dataset.loaded) return;

        section.dataset.loaded = true;

        new PremiumImageWithText(section);

    });

}

document.addEventListener('DOMContentLoaded',()=>{

    initPremiumSections();

});

/*
--------------------------------------------------
Shopify Theme Editor Support
--------------------------------------------------
*/

document.addEventListener('shopify:section:load',function(e){

    initPremiumSections(e.target);

});

document.addEventListener('shopify:section:reorder',function(){

    initPremiumSections();

});

document.addEventListener('shopify:block:select',function(e){

    const block = e.target;

    if(block){

        block.scrollIntoView({

            behavior:'smooth',

            block:'center'

        });

    }

});

/*
--------------------------------------------------
Button Ripple Effect
--------------------------------------------------
*/

document.addEventListener('click',function(e){

    const btn = e.target.closest('.piwt-btn');

    if(!btn) return;

    const ripple = document.createElement('span');

    ripple.className = 'piwt-ripple';

    const rect = btn.getBoundingClientRect();

    ripple.style.left = (e.clientX - rect.left) + 'px';

    ripple.style.top = (e.clientY - rect.top) + 'px';

    btn.appendChild(ripple);

    setTimeout(()=>{

        ripple.remove();

    },700);

});

/*
--------------------------------------------------
Parallax Image
--------------------------------------------------
*/

window.addEventListener('scroll',()=>{

    document.querySelectorAll('.piwt-image').forEach(image=>{

        const rect = image.getBoundingClientRect();

        const speed = .06;

        const offset = rect.top * speed;

        image.style.transform = `translateY(${offset}px)`;

    });

});
